import { render, staticRenderFns } from "./FieldType3.vue?vue&type=template&id=c59d3cfe&scoped=true"
import script from "./FieldType3.vue?vue&type=script&lang=js"
export * from "./FieldType3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59d3cfe",
  null
  
)

export default component.exports